import { useState } from "react";
import { FeedbackModal } from "./FeedbackModal";
import { Icon } from "./Icon";
import styles from "./SpotDescription.module.css";

interface SpotDescriptionProps {
  spotName: string;
  note?: string | undefined;
  water?: string | undefined;
  access?: string | undefined;
}

/**
 * Spot description block on the detail page — top divider, free-text
 * note, then labelled "Water" / "Access" lines, and a feedback CTA
 * card that always renders. Figma node 103:20470.
 */
export function SpotDescription({ spotName, note, water, access }: SpotDescriptionProps) {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  return (
    <section className={styles.spotDescription}>
      {note && <p className={styles.note}>{note}</p>}
      {water && (
        <div className={styles.field}>
          <span className={styles.label}>Water</span>
          <span className={styles.value}>{water}</span>
        </div>
      )}
      {access && (
        <div className={styles.field}>
          <span className={styles.label}>Access</span>
          <span className={styles.value}>{access}</span>
        </div>
      )}
      <button
        type="button"
        className={styles.feedbackCta}
        onClick={() => setFeedbackOpen(true)}
      >
        <span className={styles.feedbackCtaText}>
          Have suggestions to improve this spot? Let us know!
        </span>
        <span className={styles.feedbackCtaIcon} aria-hidden>
          <Icon name="send" />
        </span>
      </button>
      <FeedbackModal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
        spotName={spotName}
      />
    </section>
  );
}
